"use strict";
/**
 * @module kung-fu/components
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.wrapImageWithFigure = void 0;
/**
 * Wraps images with figure and figcaption elements
 * Uses the image's title or alt text as the figcaption content
 * Skips images that have the specified exclusion attribute
 *
 * @export
 * @param {string} [selector='img'] - CSS selector for images to wrap
 * @param {string} [exclusion='data-no-caption'] - Attribute that marks images to skip
 * @returns {void}
 * @example
 * // Wrap all images on the page with figure elements
 * wrapImageWithFigure();
 *
 * // Wrap only images with a specific class
 * wrapImageWithFigure('.article-image');
 *
 * // Use a custom attribute to mark images that should not be wrapped
 * wrapImageWithFigure('img', 'data-skip-figure');
 */
const wrapImageWithFigure = (selector, exclusion) => {
    selector = selector || 'img';
    exclusion = exclusion || 'data-no-caption';
    const imgs = document.querySelectorAll(selector);
    const arr = Array.from(imgs);
    arr.filter((e) => e.getAttribute(exclusion) == null)
        .forEach((img) => {
        const caption = img.getAttribute('title') || img.getAttribute('alt');
        if (caption != null) {
            const figure = document.createElement('figure');
            const figCaption = document.createElement('figcaption');
            figCaption.innerText = caption;
            figure.appendChild(img.cloneNode(true));
            figure.appendChild(figCaption);
            img.replaceWith(figure);
        }
    });
};
exports.wrapImageWithFigure = wrapImageWithFigure;
//# sourceMappingURL=figure.js.map